"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ListSelect = _interopRequireDefault(require("../01_atoms/ListSelect"));

var _TitleBlock = _interopRequireDefault(require("../01_atoms/TitleBlock"));

var _RightPaneWidgetFrame = _interopRequireDefault(require("../01_atoms/RightPaneWidgetFrame"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CitySelectionWidget = function CitySelectionWidget(_ref) {
  var title = _ref.title,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? {} : _ref$items,
      _ref$selectedItem = _ref.selectedItem,
      selectedItem = _ref$selectedItem === void 0 ? null : _ref$selectedItem,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect,
      _ref$elementStyle = _ref.elementStyle,
      elementStyle = _ref$elementStyle === void 0 ? {} : _ref$elementStyle,
      _ref$translator = _ref.translator,
      t = _ref$translator === void 0 ? function (txt) {
    return txt;
  } : _ref$translator,
      _ref$focusedLeftItemI = _ref.focusedLeftItemId,
      focusedLeftItemId = _ref$focusedLeftItemI === void 0 ? null : _ref$focusedLeftItemI,
      _ref$scrollTop = _ref.scrollTop,
      scrollTop = _ref$scrollTop === void 0 ? 0 : _ref$scrollTop;
  return /*#__PURE__*/_react["default"].createElement(_RightPaneWidgetFrame["default"], {
    scrollTop: scrollTop,
    focusedLeftItemId: focusedLeftItemId,
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_TitleBlock["default"], {
    title: title
  }, /*#__PURE__*/_react["default"].createElement(_ListSelect["default"], {
    title: title,
    items: items,
    selectedItem: selectedItem,
    onSelect: onSelect,
    translator: t
  })));
};

var _default = CitySelectionWidget;
exports["default"] = _default;